import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';

// components
import { MultiSelect } from 'ui-shared-components';

// helpers
import { useCountryOptions, type CountryOption } from '@white-label-helper/shared-composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'travel-insurance-form-step-1',
  props: {
    destination: { default: () => [] }
  },
  emits: ["update:value"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'update:value', val: CountryOption[]): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { destination: CountryOption[] };

const { countryOptions } = useCountryOptions();






// Whether the form has been touched
const dirty = ref<boolean>(false);

// Whether the current form state is valid
const isValid = computed(() => {
  return props.destination.length > 0;
})

// Whether we should show an error message
const showError = computed(() => {
  return dirty.value && !isValid.value;
})

// Sets form state to dirty in order to show error messages
const validateForm = () => {
  dirty.value = true;
}

// Sets form state to dirty and emits updated value
const updateValue = (val: CountryOption[]) => {
  dirty.value = true;
  emit('update:value', val);
}

expose({
  isValid,
  validateForm,
})

return { __sfc: true,countryOptions, props, emit, dirty, isValid, showError, validateForm, updateValue, MultiSelect }
}

})